export const acodeConfig = {
    adRequestComplete: 9910,
    adRequest: 10216,
    activityEntryClick: 10651,
    activityExposure: 10652,
    shareAction: 3032, // 分享行为上报
    expandComment: 10682, // 展开评论,
    clickImgUpload: 10947, // 点击图片上传按钮
    imgUpload: 11058, // 图片上传
    commentSubmit: 3559, // 评论提交
    clickAtButton:11114, // 点击@按钮
}